import { useContext } from 'react';
import {
  FeatureGateLabelActiveContext,
  type FeatureGateLabelActiveContextValue,
} from '../components/FeatureGateLabelActiveProvider';

export function useFeatureGateLabelActiveContext(): FeatureGateLabelActiveContextValue {
  return useContext(FeatureGateLabelActiveContext);
}
